module.exports = __webpack_public_path__ + "img/bosnia-and-herzegovina.0335c370.svg";